import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, userIdentityShape, ugcSummaryShape } from '@bibliocommons/bc-prop-types';

import shelfItemShape from 'app/shapes/shelves/shelfItemShape';
import DisplayHeading from '../../../shared/UGC/DisplayHeading';
import SummaryDisplay from '../../../shared/UGC/SummaryDisplay';

import './SummaryInfo.scss';

export default class ShelfListItemSummaryInfo extends React.PureComponent {
  render() {
    const {
      bib,
      item,
      owner,
      ownerSummaryForBib,
      summariesTransactions,
      summariesActions,
      shelfTransactions,
      shelfActions
    } = this.props;

    if (ownerSummaryForBib) {
      return (
        <div className="cp-shelf-list-item-summary-info">
          <DisplayHeading>
            <FormattedMessage id="ugc_summary_display_label" />
          </DisplayHeading>
          <SummaryDisplay
            bib={bib}
            shelfItem={item}
            owner={owner}
            summary={ownerSummaryForBib}
            summariesTransactions={summariesTransactions}
            summariesActions={summariesActions}
            shelfTransactions={shelfTransactions}
            shelfActions={shelfActions}
          />
        </div>
      );
    }

    return null;
  }
}

ShelfListItemSummaryInfo.propTypes = {
  bib: bibShape.isRequired,
  item: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  ownerSummaryForBib: ugcSummaryShape,
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};
